module.exports = __webpack_public_path__ + "img/0x2020EB9E26aa49c27ebB72C174cfbab851f7ddE0.557e04cb.png";